
import { Component, Vue, Watch } from 'vue-property-decorator'
import { State, Getter, Mutation, namespace } from 'vuex-class'

import SideMenu from './components/side-menu'
import HeaderBar from './components/header-bar'
import TagsNav from './components/tags-nav'
import User from './components/user'
import ABackTop from './components/a-back-top'
import Fullscreen from './components/fullscreen'
import { getNewTagList, routeEqual, GetToken, setRotestList, SetToken, initTableSetting, getAllTableSetting } from '@/libs/util'
import { GetAllPlatform, GetAllAppList, GetCustomePage, GetAllGameList } from '../../../api/admin/risk'
import routers from '@/router/routers'
import minLogo from '@/assets/images/logo-min.jpg'
import maxLogo from '@/assets/images/logo.png'
import { GetUserMenu } from '@/api/admin/permission'
import { GetSysConst } from '@/api/admin/user'
const userModule = namespace('user')
Component.registerHooks(['beforeRouteLeave'])
@Component({
    components: {
        SideMenu,
        HeaderBar,
        // Language,
        TagsNav,
        Fullscreen,
        // ErrorStore,
        User,
        ABackTop
    }
})
export default class Main extends Vue {
    @userModule.Action
    handleLogin
    // @userModule.Action getUnreadMessageCount;
    @userModule.State
    unreadCount
    @Mutation
    setBreadCrumb
    @Mutation
    setTagNavList
    @Mutation
    addTag
    @Mutation
    setLocal
    @Mutation
    setHomeRoute
    @Mutation
    closeTag
    @Getter
    errorCount
    @Mutation
    setPlatList
    @Mutation
    setAppList
    // @Getter menuList;
    @State((state) => state.app.tagNavList)
    tagNavList
    @State((state) => state.app.tagRouter)
    tagRouter
    @State((state) => state.app.avatarImgPath)
    userAvatar
    @State((state) => state.app.local)
    local
    @State((state) => state.app.hasReadErrorPage)
    hasReadErrorPage

    private router = ''
    private menuTips: any = []
    name = 'Main'
    collapsed = false
    minLogo = minLogo
    maxLogo = maxLogo
    isFullscreen = false
    menuList: any = []
    roterList: any = []
    cacheList: any = []
    turnToPage(route) {
        let name, params, query
        if (typeof route === 'string') name = route
        else {
            name = route.name
            params = route.params
            query = route.query
        }
        if (name.indexOf('isTurnByHref_') > -1) {
            window.open(name.split('_')[1])
            return
        }

        this.$router.push({
            name,
            params,
            query
        })
    }
    handleCollapsedChange(state) {
        this.collapsed = state
    }

    handleCloseTag(res, type, route) {
        if (type !== 'others') {
            if (type === 'all') {
                this.turnToPage((this as any).$config.homeName)
            } else {
                if (routeEqual(this.$route, route)) {
                    this.closeTag(route)
                }
            }
        }
        this.setTagNavList(res)
    }
    handleRefresh(res, type, route) {
        if (route && route.name) {
            let arr: any = route.name.split('_')
            let str: String = arr[1]
            if (str) {
                let name1 = str.replace(str[0], str[0].toUpperCase())
                let name2 = str.replace(str[0], str[0].toLowerCase())
                this.cacheList = [name1, name2]
                this.$nextTick(() => {
                    this.cacheList = []
                })
            }
        }
    }
    handleClick(item) {
        this.turnToPage(item)
    }
    @Watch('$route')
    routeChanged(newRoute) {
        let { name, query, params, meta } = newRoute
        this.addTag({ route: { name, query, params, meta }, type: 'push' })
        this.setBreadCrumb(newRoute)
        this.setTagNavList(getNewTagList(this.tagNavList, newRoute))
        ;(this.$refs.sideMenu as SideMenu).updateOpenName(newRoute.name)
    }

    allMenu() {
        let param = {
            user_id: GetToken().uid
        }
        GetUserMenu(param).then((res: any) => {
            let data = res['_param'].list[0].children || []
            let menuLi: any = []
            this.menuTips = []
            data.map((item, index) => {
                let menuLiChlid: any = []
                item.children.map((item1, index1) => {
                    let menuLiChlid1: any = []
                    let nav = this.tagNavList.find((el: any) => el.name == item1.classname)
                    if (nav) {
                        nav.meta.title = item1.title
                    }
                    let target
                    ;(this.$router['options'] as any).routes.some((el: any) => {
                        if (el.children) {
                            target = el.children.find((ek: any) => ek.name == item1.classname)
                            return target
                        }
                        return target
                    })
                    if (target) {
                        target.meta.title = item1.title
                    }
                    item1.children.map((item2, index2) => {
                        let cldata = {
                            icon: item2.icon,
                            name: item2.classname,
                            meta: { icon: item2.icon, title: item2.title }
                        }
                        menuLiChlid1.push(cldata)
                    })
                    let cldata1 = {
                        icon: item1.icon,
                        name: item1.classname,
                        meta: { icon: item1.icon, title: item1.title },
                        children: menuLiChlid1
                    }
                    menuLiChlid.push(cldata1)
                    let obj = {
                        value: '/' + item.url + '/' + item1.url,
                        label: item1.title
                    }
                    this.menuTips.push(obj)
                })
                let mldata = {
                    icon: item.icon,
                    name: item.classname,
                    index: index + 1,
                    meta: { icon: item.icon, title: item.title },
                    children: menuLiChlid
                }
                menuLi.push(mldata)
            })
            this.menuList = menuLi
            let list: any = []
            this.menuList.map((item) => {
                item.children.map((item1) => {
                    list.push(item1.name)
                })
            })
            setRotestList(list)
        })
    }

    getGameList() {
        const param = {
            gtype: 0,
            page: 1,
            page_size: 10000
        }
        GetAllGameList(param).then((res) => {
            const data = res._param.data
            const nlist: Array<any> = []

            data.map((item) => {
                nlist.push({
                    value: item.game_id,
                    name: item.game_name,
                    ...item
                })
            })
            localStorage.setItem('gameList', JSON.stringify(nlist))
        })
    }

    // 获取系统常量
    getSysConst() {
        GetSysConst({}).then((res) => {
            SetToken({ SysConstType: res['_param'] })
        })
    }
    async created() {
        let listResult: any = []
        if (document.documentElement.clientWidth < 737) {
            this.collapsed = true
        }
        /**
         * @description 初始化设置面包屑导航和标签导航
         */
        this.getCustomePage()
        this.GetAllPlatform()
        this.GetAllAppList()
        this.allMenu()
        this.getGameList();
        (this as any).getinitPlatId()
    }
    //获取所有分组
    async GetAllPlatform() {
        GetAllPlatform({}).then(async (res) => {
            let plat_list = res._param.data || []
            this.setPlatList(plat_list)
            SetToken({ plat_list })
        })
    }
    getCustomePage() {
        if (GetToken().uid) {
            GetCustomePage({ uid: GetToken().uid, path: 'userTableSetting' }).then((res) => {
                var info = { init: {} }
                if (res._param.custome) {
                    try {
                        info = JSON.parse(res._param.custome)
                    } catch (error) {}
                }
                initTableSetting(info)
            })
        }
    }
    async GetAllAppList() {
        GetAllAppList({}).then((res) => {
            let app_list = res._param.List || []
            this.setAppList(app_list)
        })
    }
    routego(tip) {
        let obj = {
            value: '',
            label: tip
        }
        this.menuTips.map((item) => {
            if (item.label == tip) {
                obj.value = item.value
            }
        })
        this.routerTips(obj as any)
    }
    routerTips(obj) {
        let jsonobj = obj
        if (obj === undefined || obj.label === undefined) {
            return false
        }
        this.menuTips.map((item) => {
            if (item.label == jsonobj.label) {
                jsonobj.value = item.value
            }
        })
        let list: any = []
        this.menuTips.map((item) => {
            list.push(item.label)
        })

        if (list.includes(jsonobj.label)) {
            this.$router.push(jsonobj.value)
        } else {
            this.$Message.error('请输入正确的子页签名称')
            // return false
        }
    }
    beforeRouteLeave(to, from, next) {
        if (this.$vnode && (this.$vnode as any)['data'].keepAlive) {
            if (this.$vnode.parent && this.$vnode.parent.componentInstance && this.$vnode.parent.componentInstance['cache']) {
                if (this.$vnode.componentOptions) {
                    const cache = this.$vnode.parent.componentInstance['cache']
                    const keys = this.$vnode.parent.componentInstance['keys']
                    const waitDelKeys: any = Object.values(keys)
                    // keys.forEach((k) => {
                    //     // 判断是否缓存了同类页面
                    //     if (/\/user\/user-service\//.test(k)) {
                    //         // 非自己页面，把key存入待销毁数组里
                    //         if (k.indexOf(this.$route.fullPath) === -1) {
                    //             waitDelKeys.push(k);
                    //         }
                    //     }
                    // });
                    // 销毁缓存
                    waitDelKeys.forEach((wk) => {
                        const index = keys.indexOf(wk)
                        keys.splice(index, 1)
                        delete cache[wk]
                    })
                }
            }
        }
        next()
    }
    mounted() {
        this.setTagNavList()
        this.getSysConst()
        this.setHomeRoute(routers)
        const { name, params, query, meta } = this.$route
        this.addTag({
            route: { name, params, query, meta }
        })
        this.setBreadCrumb(this.$route)
        // document.writeln(JSON.stringify(this.menuList))
        // 设置初始语言
        // 如果当前打开页面不在标签栏中，跳到homeName页

        if (!this.tagNavList.find((item) => item.name === this.$route.name)) {
            this.$router.push({
                name: (this as any).$config.homeName
            })
        }
        // 获取未读消息条数
        // this.getUnreadMessageCount();
    }
}
